import { render, staticRenderFns } from "./MultiRiskCell.vue?vue&type=template&id=63781292&scoped=true"
import script from "./MultiRiskCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiRiskCell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MultiRiskCell.vue?vue&type=style&index=0&id=63781292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63781292",
  null
  
)

export default component.exports